export function permissionAbility(userLevel, page, feature) {
  let ability = false;

  const features = {
    "org-level": {
      view: ["Manager", "Admin", "Super-Admin"],
      add: ["Super-Admin"],
      edit: ["Super-Admin"],
      delete: ["Super-Admin"],
    },
    "plan-templates": {
      view: ["Manager", "Admin", "Super-Admin"],
      add: ["Super-Admin"],
      edit: ["Super-Admin"],
      delete: ["Super-Admin"],
    },
    "plan-levels": {
      view: ["Manager", "Admin", "Super-Admin"],
      add: ["Super-Admin"],
      edit: ["Super-Admin"],
      delete: ["Super-Admin"],
    },
    designations: {
      view: ["User", "Manager", "Admin", "Super-Admin"],
      add: ["Admin", "Manager", "Super-Admin"],
      edit: ["Admin", "Manager", "Super-Admin"],
      delete: ["Admin", "Manager", "Super-Admin"],
    },
    "plan-groups": {
      view: ["User", "Manager", "Admin", "Super-Admin"],
      add: ["Admin", "Super-Admin"],
      edit: ["Admin", "Super-Admin"],
      delete: ["Admin", "Super-Admin"],
    },
    "plan-attributes": {
      view: ["User", "Manager", "Admin", "Super-Admin"],
      add: ["Admin", "Super-Admin"],
      edit: ["Admin", "Super-Admin"],
      delete: ["Admin", "Super-Admin"],
    },
    scales: {
      view: ["User", "Manager", "Admin", "Super-Admin"],
      add: ["Admin", "Super-Admin"],
      edit: ["Admin", "Super-Admin"],
      delete: ["Admin", "Super-Admin"],
    },
    general: {
      view: ["Admin", "Super-Admin"],
    },
    organization: {
      view: ["Admin", "Super-Admin"],
      add: ["Manager", "Admin", "Super-Admin"],
      edit: ["Manager", "Admin", "Super-Admin"],
      delete: ["Manager", "Admin", "Super-Admin"],
    },
    units: {
      view: ["User", "Manager", "Admin", "Super-Admin"],
      add: ["Manager", "Admin", "Super-Admin"],
      edit: ["Manager", "Admin", "Super-Admin"],
      delete: ["Manager", "Admin", "Super-Admin"],
    },
    positions: {
      view: ["Admin", "Super-Admin"],
      add: ["Super-Admin"],
      edit: ["Super-Admin"],
      delete: ["Super-Admin"],
    },
    users: {
      view: ["Admin", "Super-Admin"],
      add: ["Manager", "Admin", "Super-Admin"],
      edit: ["Manager", "Admin", "Super-Admin"],
      delete: ["Super-Admin"],
    },
    "perf-cycles": {
      view: ["Admin", "Super-Admin"],
      add: ["Super-Admin"],
      edit: ["Super-Admin"],
      delete: ["Super-Admin"],
      manage: ["Super-Admin"],
    },
    plans: {
      view: ["User", "Manager", "Admin", "Super-Admin"],
      add: ["Manager", "Admin", "Super-Admin"],
      edit: ["Manager", "Admin", "Super-Admin"],
      delete: ["Manager", "Admin", "Super-Admin"],
      cascade: ["Super-Admin"],
      split: ["Manager", "Admin", "Super-Admin"],
    },
  };

  const pageLevel = features[page];
  const featureLevel = pageLevel[feature];

  if (featureLevel.includes(userLevel)) {
    ability = true;
  }
  return ability;
}
